import { useQuery } from 'react-query'
import { getMoneyPoolManagement } from 'services/fund'

export default function useGetMoneyPoolManagement(id: string | undefined) {
    const { data, isLoading, isError, refetch } = useQuery(
        ['moneyPool-management', id],
        getMoneyPoolManagement
    )
    return {
        moneyPoolManagement: data,
        isLoadingMoneypoolManagement: isLoading,
        isErrorMoneypoolManagement: isError,
        refetch,
    }
}
